import { render, staticRenderFns } from "./CoozzyAddressBookIcon.vue?vue&type=template&id=33bf153a&scoped=true"
import script from "./CoozzyAddressBookIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAddressBookIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAddressBookIcon.vue?vue&type=style&index=0&id=33bf153a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf153a",
  null
  
)

export default component.exports